var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !(_vm.currentBetSlipState == 5 && _vm.betSlipStatus.State == 2)
    ? _c(
        "div",
        { staticClass: "betSlipTabs", attrs: { id: "betSlipTabs" } },
        [
          !_vm.betslipLayout2
            ? [
                _c("div", { staticClass: "betslipHeader" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "tabs is-boxed is-centered is-fullwidth is-toggle",
                      attrs: { id: "tabBtns" }
                    },
                    _vm._l(_vm.betSlipTabs, function(t) {
                      return _c(
                        "span",
                        {
                          staticClass: "tab",
                          class: { active: _vm.tab === t, disabled: true }
                        },
                        [
                          _c(
                            "a",
                            {
                              class: { disabled: _vm.betsNo === 0 },
                              on: {
                                click: function($event) {
                                  return _vm.setTab(t)
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("BetSlip.tab." + t)))
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.betsNo
            ? _c("div", { staticClass: "Tabs" }, [
                _vm.tab === "REGULAR"
                  ? _c(
                      "div",
                      [
                        _c("tab-regular", {
                          attrs: {
                            tab: _vm.tab,
                            betsNo: _vm.betsNo,
                            currentBetSlipState: _vm.currentBetSlipState,
                            allowedBetTypesAndReturns:
                              _vm.allowedBetTypesAndReturns[_vm.tab]
                                .PotentialReturns,
                            allowedBetTypesAndReturnsXP:
                              _vm.allowedBetTypesAndReturns.XP,
                            betTypeStakes: _vm.betTypeStakes[_vm.tab],
                            betTypeStakesXP: _vm.betTypeStakes.XP,
                            gettingABTnR: _vm.gettingABTnR,
                            interRelated: _vm.interRelated,
                            allowedMultiSingles: _vm.allowedMultiSingles
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === "TEASER"
                  ? _c(
                      "div",
                      [
                        _c("tab-teaser", {
                          attrs: {
                            tab: _vm.tab,
                            currentBetSlipState: _vm.currentBetSlipState,
                            betsNo: _vm.betsNo,
                            allowedBetTypesAndReturns:
                              _vm.allowedBetTypesAndReturns[_vm.tab],
                            betTypeStakes: _vm.betTypeStakes[_vm.tab],
                            gettingABTnR: _vm.gettingABTnR,
                            interRelated: _vm.interRelated
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === "RR"
                  ? _c(
                      "div",
                      [
                        _c("tab-rr", {
                          attrs: {
                            tab: _vm.tab,
                            currentBetSlipState: _vm.currentBetSlipState,
                            betsNo: _vm.betsNo,
                            allowedBetTypesAndReturns:
                              _vm.allowedBetTypesAndReturns[_vm.tab]
                                .PotentialReturns,
                            betTypeStakes: _vm.betTypeStakes[_vm.tab],
                            gettingABTnR: _vm.gettingABTnR,
                            interRelated: _vm.interRelated
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bba4f1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bba4f1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/rootElements/tabs.vue
// module id = null
// module chunks = 